import Udesk from 'Udesk';
import UdeskLocales from 'UdeskLocales';
import React from 'react';
import { Modal, Icon, Row, Col, Tabs, Spin, Alert, Select } from 'udesk-ui';
import AudioStickers from '../audio-stickers-talk';
import WaveAudio from '../../../common/wave-audio-talk';
import SmartTags from '../smart-tags';
import ChangeList from '../change-list';
import AudioCallContentInfo from 'Component/pages/components/audio-call-content-info';
import ApplyTemplates from '../apply-templates';
import { ReportEcharts } from 'udesk-react/src/components/report/report-echarts';
import CallTextView from '../call-text-view';
import EmotionsAnalysis from '../emotion-analysis';
import RecordDetailComponent from './component';
import RelatedRecordsList from '../related-records-list';
import AddToTask from './components/AddToTask';
import ControlVideo from '../ControlVideo';
import AssociatedTicket from 'src/components/common/AssociatedTicket';
import { transformToTickets } from 'src/components/common/AssociatedTicket/utils';
import CustomerInformation from 'src/components/common/CustomerInformation';
import CustomFiledList from 'src/components/common/CustomFiledList';
import DialogInformation from 'src/components/common/DialogInformation';
import HandleTime from 'src/components/common/HandleTime';
import { TAG_TYPE } from 'Component/pages/intelligent-analysis/intelligent-tags/const';
import TemplateTitle from './components/TemplateTitle';
import { hasFeature } from 'src/util/permit';
import { isQaSubApp } from 'Udesk/system/subApp';
import ClassNames from 'classnames';
import _isEmpty from 'lodash-es/isEmpty';
import _map from 'lodash-es/map';
import ProblemExtraction from 'src/components/pages/components/quality-check-score-talk/components/ProblemExtraction';
import './style.scss';

export default class RecordDetailTemplate extends RecordDetailComponent {
    render() {
        let { sdkOptions, inspectDataSource, keywords, keywordType } = this.props;
        let {
            detail,
            smartTags,
            templates,
            selectedDatum,
            showEmotionAnalysis,
            // semanticMarkShow,
            // semanticContent,
            relatedDatas,
            relatedLoading,
            visible,
            labelRef,
            treeDataList,
            treeDataRef,
            labelParentModal,
            labelActiveModal,
            hitData,
            timeValue,
            waveAudio,
            waveAudioOptions,
            spinLoading,
            changeListLoading,
            changeList,
            taskType,
            // taskList,
            videoRef,
            ticketIndex,
            highlightGroupList,
            activeKey,
        } = this.privates;
        let { relatedDatasPaging } = this.privates.storages;
        let { actions, locales, privates } = this;

        let keywordWordCloudUrl = Udesk.business.apiPath.concatApiPath(
            `data/${selectedDatum.dataId}/keywords`,
            sdkOptions
        );

        const isComment =
            inspectDataSource === Udesk.enums.inspectDataSources.eComment.id ||
            inspectDataSource === Udesk.enums.inspectDataSources.mComment.id;

        const tickets = transformToTickets(detail);

        return (
            <div className="qa-react-record-detail-page qa-react-record-detail-page-info">
                <div className="qa-react-record-detail-page-info">
                    <Choose>
                        <When condition={detail}>
                            {!!detail.isHideText && (
                                <Alert
                                    message={
                                        /* 该数据已被定期清除 */ UdeskLocales['current'].components
                                            .recordDetail.template.theDataHasBeenClearedPeriodically
                                    }
                                    type="info"
                                    showIcon
                                    style={{ marginBottom: 8 }}
                                />
                            )}
                            <If condition={!showEmotionAnalysis}>
                                <div className="qa-react-record-detail-media-container">
                                    <If condition={detail.videoUrl}>
                                        <div className="qa-react-record-detail-media-video">
                                            <ControlVideo
                                                src={detail.videoUrl}
                                                forwardRef={videoRef}
                                                onTimeChange={actions.videoTimeChange}
                                                onPlay={actions.onVideoPlay}
                                            />
                                        </div>
                                    </If>

                                    <If condition={detail.voiceUrl}>
                                        <div className="qa-react-record-detail-media-audio">
                                            <AudioStickers detail={detail} />
                                            <WaveAudio
                                                reverse={this.actions.reverse}
                                                recover={this.actions.recover}
                                                reAsr={this.actions.reAsr}
                                                agentFlag={false}
                                                onWaveAudio={actions.onWaveAudio}
                                                options={waveAudioOptions}
                                                timeChaged={actions.timeChaged}
                                                detail={detail}
                                                isShowEmotionButton={true}
                                                src={detail.voiceUrl}
                                                onClickEmotionAnalysis={
                                                    actions.changeShowEmotionAnalysis
                                                }
                                                ref={(instance) => {
                                                    this.privates.waveAudioInstance = instance;
                                                }}
                                                onWaveSeek={(value) => {
                                                    this.privates.videoRef.current?.updateCurrentTime?.(
                                                        value
                                                    );
                                                }}
                                                onWavePlay={() => {
                                                    this.privates.videoRef.current?.pause?.();
                                                }}
                                            />
                                        </div>
                                    </If>
                                </div>
                            </If>
                            <If condition={showEmotionAnalysis}>
                                <div className="qa-react-record-detail-emotion-analysis-container">
                                    <button
                                        type="button"
                                        className="btn btn-xs btn-default qa-react-record-detail-emotion-button"
                                        onClick={actions.changeShowEmotionAnalysis}
                                    >
                                        {
                                            locales.components.pages.components.recordDetail
                                                .showWaveAudio
                                        }
                                    </button>
                                    <EmotionsAnalysis
                                        detail={detail}
                                        classNames="qa-react-record-detail-emotion-analysis"
                                    />
                                </div>
                            </If>
                            <If
                                condition={
                                    inspectDataSource === Udesk.enums.inspectDataSources.ticket.id
                                }
                            >
                                <div
                                    style={{
                                        marginBottom: 8,
                                        padding: 16,
                                        backgroundColor: '#fff',
                                    }}
                                >
                                    <div>{`${
                                        /* 主题： */ locales.components.recordDetail.template
                                            .subject
                                    }${detail.ticketSubject}`}</div>
                                    <div>{`${
                                        /* 描述： */ locales.components.recordDetail.template
                                            .description
                                    }${detail.ticketContentPlain}`}</div>
                                </div>
                            </If>
                            <If
                                condition={
                                    inspectDataSource !== Udesk.enums.inspectDataSources.ticket.id
                                }
                            >
                                <SmartTags
                                    callId={detail.id}
                                    onSmartTagsChange={actions.onSmartTagsChange}
                                    smartTags={smartTags}
                                    smartTagsTitle={
                                        locales.components.pages.appealChekingTask.list.smartTags
                                    }
                                    treeListVisible={actions.treeListVisible}
                                    funcType={TAG_TYPE.QUALITY_INSPECT}
                                />
                            </If>
                            <div
                                className={ClassNames('qa-react-record-detail-content row', {
                                    'with-audio': detail.voiceUrl,
                                })}
                            >
                                <Row gutter={16} style={{ height: '100%' }}>
                                    <Col
                                        className="gutter-row qa-react-record-detail-content-left-part"
                                        span={12}
                                    >
                                        <AudioCallContentInfo
                                            isRecordDetail={true}
                                            onAudioStop={actions.onAudioStop}
                                            trainRecords={actions.trainRecords}
                                            waveAudio={waveAudio}
                                            onAudioPause={actions.onAudioPause}
                                            timeValue={timeValue}
                                            testSetListFlag={true}
                                            sentenceList={
                                                detail &&
                                                detail.dialogRecords &&
                                                detail.dialogRecords.dialogSentenceList
                                            }
                                            key={detail.id}
                                            detail={detail}
                                            keywords={keywords}
                                            keywordType={keywordType}
                                            inspectDataSource={inspectDataSource}
                                            onTimeRangeChanged={actions.sendCurrentTimeRange}
                                            onMarkSemanticClick={actions.markSemantic}
                                            reTranslate={this.actions.reTranslate}
                                            highlightGroupList={highlightGroupList}
                                            onCloseHitClick={actions.closeHitClick}
                                        />
                                    </Col>
                                    <Col
                                        className="gutter-row qa-react-record-detail-content-right-part"
                                        span={12}
                                        style={{ display: 'flex', flexDirection: 'column' }}
                                    >
                                        {isQaSubApp() && !isComment ? (
                                            <div
                                                className="qa-react-record-detail-content-templates"
                                                style={{ flex: 1, marginBottom: '6px' }}
                                            >
                                                <ApplyTemplates
                                                    title={
                                                        <TemplateTitle
                                                            taskType={taskType}
                                                            onTaskTypeChange={
                                                                actions.onTaskTypeChange
                                                            }
                                                            showCollection={
                                                                inspectDataSource !==
                                                                    Udesk.enums.inspectDataSources
                                                                        .ticket.id &&
                                                                inspectDataSource !==
                                                                    Udesk.enums.inspectDataSources
                                                                        .wechatRadio.id
                                                            }
                                                        />
                                                    }
                                                    extra={
                                                        Udesk.business.task.isVoiceCall(
                                                            inspectDataSource
                                                        ) ? (
                                                            <AddToTask
                                                                onAdded={() => {
                                                                    this.actions.reloadAsyncModel();
                                                                }}
                                                                dataId={selectedDatum.dataId}
                                                                inspectDataSource={
                                                                    this.props.inspectDataSource
                                                                }
                                                                lang={detail?.lang}
                                                            />
                                                        ) : null
                                                    }
                                                    templates={templates.filter(
                                                        (i) => i.taskType === taskType
                                                    )}
                                                    onClickTemplate={actions.transitionToTemplate}
                                                    onRefresh={actions.getTemplates}
                                                />
                                            </div>
                                        ) : null}

                                        <div className="qa-react-record-detail-content-word-cloud">
                                            <Tabs
                                                activeKey={activeKey}
                                                onChange={actions.onTabsChange}
                                            >
                                                <Tabs.TabPane
                                                    tab={
                                                        Udesk.enums.inspectDataSources.getName(
                                                            inspectDataSource
                                                        ) +
                                                        /* 信息 */ UdeskLocales['current']
                                                            .components.recordDetail.template
                                                            .information
                                                    }
                                                    key="2"
                                                >
                                                    <div
                                                        style={{
                                                            height: 'calc(347px - 46px)',
                                                            overflowY: 'auto',
                                                        }}
                                                    >
                                                        <If
                                                            condition={
                                                                detail &&
                                                                detail.fieldList &&
                                                                detail.fieldList.length > 0
                                                            }
                                                        >
                                                            <CallTextView
                                                                callInfoList={detail.fieldList}
                                                                fieldValueMap={detail.fieldValueMap}
                                                            />
                                                        </If>
                                                    </div>
                                                </Tabs.TabPane>

                                                {[
                                                    Udesk.enums.inspectDataSources.voiceCall.id,
                                                    Udesk.enums.inspectDataSources.textDialogue.id,
                                                ].includes(inspectDataSource) ? (
                                                    <Tabs.TabPane
                                                        tab={
                                                            /* 工单信息 */ UdeskLocales['current']
                                                                .components.audioCallBasicInfoV2
                                                                .template.workOrderInformation
                                                        }
                                                        key={`4`}
                                                    >
                                                        <div
                                                            className="audio-text-view"
                                                            style={{
                                                                height: 'calc(347px - 46px)',
                                                                overflowY: 'auto',
                                                            }}
                                                        >
                                                            {Array.isArray(
                                                                detail.ticketInfoList
                                                            ) && (
                                                                <>
                                                                    {detail.ticketInfoList.length >
                                                                        1 && (
                                                                        <Select
                                                                            options={detail.ticketInfoList.map(
                                                                                (t, i) => ({
                                                                                    label:
                                                                                        t.fieldNum ||
                                                                                        `${
                                                                                            /* 工单 */ UdeskLocales[
                                                                                                'current'
                                                                                            ]
                                                                                                .components
                                                                                                .audioCallBasicInfoV2
                                                                                                .template
                                                                                                .workOrder
                                                                                        }${i + 1}`,
                                                                                    value: i,
                                                                                })
                                                                            )}
                                                                            onChange={
                                                                                this.actions
                                                                                    .onTicketChange
                                                                            }
                                                                            style={{
                                                                                width: '100%',
                                                                                marginTop: 8,
                                                                                padding: '0 8px',
                                                                            }}
                                                                            value={ticketIndex}
                                                                        />
                                                                    )}
                                                                    {detail.ticketInfoList.length >
                                                                        0 && (
                                                                        <If
                                                                            condition={
                                                                                detail
                                                                                    .ticketInfoList[
                                                                                    ticketIndex
                                                                                ]
                                                                            }
                                                                        >
                                                                            <div>
                                                                                <CallTextView
                                                                                    thirdParty={
                                                                                        this.props
                                                                                            .thirdParty
                                                                                    }
                                                                                    callInfoList={
                                                                                        detail
                                                                                            .ticketInfoList[
                                                                                            ticketIndex
                                                                                        ].fieldList
                                                                                    }
                                                                                    fieldValueMap={
                                                                                        detail
                                                                                            .ticketInfoList[
                                                                                            ticketIndex
                                                                                        ]
                                                                                            .fieldValueMap
                                                                                    }
                                                                                />
                                                                            </div>
                                                                        </If>
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>
                                                    </Tabs.TabPane>
                                                ) : null}

                                                {[
                                                    Udesk.enums.inspectDataSources.voiceCall.id,
                                                    Udesk.enums.inspectDataSources.textDialogue.id,
                                                ].includes(inspectDataSource) &&
                                                hasFeature('ticket:relate:root') ? (
                                                    <Tabs.TabPane
                                                        tab={
                                                            /* 关联工单 */ UdeskLocales['current']
                                                                .components.recordDetail.template
                                                                .associatedWorkOrder
                                                        }
                                                        key="3"
                                                    >
                                                        <AssociatedTicket
                                                            height={300}
                                                            tickets={tickets}
                                                        />
                                                    </Tabs.TabPane>
                                                ) : null}

                                                {[
                                                    Udesk.enums.inspectDataSources.voiceCall.id,
                                                    Udesk.enums.inspectDataSources.textDialogue.id,
                                                    Udesk.enums.inspectDataSources.ticket.id,
                                                ].includes(inspectDataSource) ? (
                                                    <Tabs.TabPane
                                                        tab={
                                                            /* 客户信息 */ UdeskLocales['current']
                                                                .components.recordDetail.template
                                                                .customerInformation
                                                        }
                                                        key="5"
                                                    >
                                                        <CustomerInformation
                                                            height={300}
                                                            callId={detail.id}
                                                        />
                                                    </Tabs.TabPane>
                                                ) : null}

                                                {[
                                                    Udesk.enums.inspectDataSources.ticket.id,
                                                ].includes(inspectDataSource) ? (
                                                    <Tabs.TabPane
                                                        tab={
                                                            /* 通对话信息 */ UdeskLocales['current']
                                                                .components.recordDetail.template
                                                                .communicationDialogueInformation
                                                        }
                                                        key="8"
                                                    >
                                                        <DialogInformation
                                                            height={300}
                                                            callId={detail.id}
                                                        />
                                                    </Tabs.TabPane>
                                                ) : null}

                                                {[
                                                    Udesk.enums.inspectDataSources.ticket.id,
                                                ].includes(inspectDataSource) ? (
                                                    <>
                                                        <Tabs.TabPane
                                                            tab={
                                                                /* 自定义字段 */ UdeskLocales[
                                                                    'current'
                                                                ].components.recordDetail.template
                                                                    .customFields
                                                            }
                                                            key="6"
                                                        >
                                                            <CustomFiledList
                                                                height={300}
                                                                customFields={
                                                                    detail.noteInfoExtension
                                                                        ?.noteInfo
                                                                        ?.note_custom_fields
                                                                }
                                                            />
                                                        </Tabs.TabPane>

                                                        <Tabs.TabPane
                                                            tab={
                                                                /* 处理时间 */ UdeskLocales[
                                                                    'current'
                                                                ].components.recordDetail.template
                                                                    .processingTime
                                                            }
                                                            key="9"
                                                        >
                                                            <HandleTime
                                                                height={300}
                                                                customFields={
                                                                    detail.noteInfoExtension
                                                                        ?.noteInfo
                                                                        ?.note_custom_time_fields
                                                                }
                                                            />
                                                        </Tabs.TabPane>
                                                    </>
                                                ) : null}

                                                {hasFeature('sys:largeAi:question:extract', () => (
                                                    <Tabs.TabPane
                                                        tab={
                                                            /* 问题抽取 */ UdeskLocales['current']
                                                                .components.recordDetail.template
                                                                .problemExtraction
                                                        }
                                                        key="7"
                                                    >
                                                        <ProblemExtraction
                                                            callId={detail.id}
                                                            onLocate={
                                                                actions.onProblemExtractionLocate
                                                            }
                                                            height={300}
                                                            defaultQuestionId={
                                                                this.privates.defaultQuestionId
                                                            }
                                                        />
                                                    </Tabs.TabPane>
                                                ))}

                                                {inspectDataSource !==
                                                    Udesk.enums.inspectDataSources.ticket.id && (
                                                    <Tabs.TabPane
                                                        tab={locales.fix.keywordsWordCloud}
                                                        key="1"
                                                    >
                                                        <div id="reacordDetailKeyWordsCloud">
                                                            <ReportEcharts
                                                                ref={privates.wordCloudRef}
                                                                classNames="key-words-cloud"
                                                                chartType={
                                                                    Udesk.enums.echartTypes
                                                                        .wordCloud.id
                                                                }
                                                                chartDataUrl={keywordWordCloudUrl}
                                                                sdkOptions={sdkOptions}
                                                                rerenderOptimization={true}
                                                                onSeriesClicked={
                                                                    actions.onSeriesClicked
                                                                }
                                                            />
                                                        </div>
                                                    </Tabs.TabPane>
                                                )}
                                            </Tabs>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div style={{ marginTop: '16px' }}>
                                <h2 style={{ fontWeight: 'bold' }}>
                                    {
                                        locales.components.pages.appealChekingTask.components
                                            .relatedRecord.title
                                    }
                                </h2>
                            </div>
                            {relatedDatas && !_isEmpty(relatedDatas) ? (
                                <div>
                                    <RelatedRecordsList
                                        relatedDatas={relatedDatas}
                                        relatedDatasPaging={relatedDatasPaging}
                                        parentLoadMore={actions.parentLoadMore}
                                        loading={relatedLoading}
                                        selectedDatum={selectedDatum && selectedDatum.dataId}
                                    />
                                </div>
                            ) : (
                                <Spin spinning={spinLoading}>
                                    {spinLoading ? (
                                        <div style={{ width: '100%', height: '30px' }}></div>
                                    ) : (
                                        <div
                                            style={{
                                                width: '100%',
                                                height: '30px',
                                                textAlign: 'center',
                                                lineHeight: '30px',
                                            }}
                                        >
                                            {locales.labels.dataNo}
                                        </div>
                                    )}
                                </Spin>
                            )}
                            <ChangeList
                                list={changeList}
                                pointCategoryList={detail.pointCategoryList || []}
                                loading={changeListLoading}
                            />
                        </When>
                        <Otherwise>
                            <div className="qa-react-record-detail-page-no-value">
                                {locales.labels.noValue}
                            </div>
                        </Otherwise>
                    </Choose>

                    <Modal
                        title={locales.fix.editCategoryLabel}
                        visible={visible}
                        onCancel={actions.modalCancel}
                        onOk={actions.modalOk}
                    >
                        <div className="label-tabs-list-page" ref={labelRef}>
                            {!_isEmpty(treeDataList) &&
                                _map(treeDataList, (item, index) => {
                                    if (item) {
                                        return (
                                            <div
                                                className="label-tabs-list-page-field"
                                                key={index}
                                                style={{ width: '190px' }}
                                                ref={treeDataRef[`tree-${index}`]}
                                                onMouseUp={actions.fieldUp.params(labelRef)}
                                            >
                                                <div
                                                    className="label-field-target-drag"
                                                    onMouseDown={actions.treeDrag.params(
                                                        treeDataRef[`tree-${index}`],
                                                        labelRef
                                                    )}
                                                >
                                                    <Icon type="ic-pause-zanting" />
                                                </div>
                                                <div className="label-tabs-list-page-field-drag">
                                                    {!_isEmpty(item) &&
                                                        item.map((items) => {
                                                            return (
                                                                <div
                                                                    className={ClassNames(
                                                                        'label-field-info',
                                                                        {
                                                                            'label-field-info-active-parent':
                                                                                labelParentModal[
                                                                                    items.tagLevel
                                                                                ] === items.id ||
                                                                                hitData[
                                                                                    items.tagLevel
                                                                                ] === items.id,
                                                                        },
                                                                        {
                                                                            'label-field-info-active':
                                                                                items.id ===
                                                                                labelActiveModal,
                                                                        }
                                                                    )}
                                                                    key={items.id}
                                                                    onClick={actions.activesLabelModal.params(
                                                                        items.id,
                                                                        items.tagLevel,
                                                                        items.leafFlag
                                                                    )}
                                                                >
                                                                    <span>{items.tagName}</span>
                                                                    {items.leafFlag !== 1 && (
                                                                        <Icon type="ic-play-line" />
                                                                    )}
                                                                </div>
                                                            );
                                                        })}
                                                </div>
                                            </div>
                                        );
                                    } else {
                                        return;
                                    }
                                })}
                        </div>
                    </Modal>
                </div>
            </div>
        );
    }
}
